import type { ContentStep } from '@cfa/pathway-fe-shared/xp';

import Constants from '@/constants';

/**
 * Whether a step counts toward "all steps complete".
 *
 * A document step whose resource never resolved can't be completed, so it is
 * excluded. Every other step type always counts.
 */
export const isCountableStep = (step: ContentStep) =>
  step.type !== Constants.STEP_TYPES.DOCUMENT || !!step.available;
